import {DispatchEntity, dispatchesSelector, useGetSplitDispatchesByDispatchQuery} from "@ots-frontend/ots-data";
import {Card, Divider, Grid, Group, Title} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {skipToken} from "@reduxjs/toolkit/query";
import {DispatchDataTable} from "../../data-table/DispatchDataTable/DispatchDataTable";

export type DispatchSplitsCardProps = {
  dispatch: DispatchEntity
}

export const DispatchSplitsCard = (props: DispatchSplitsCardProps) => {
  const {dispatch} = props

  const {t} = useTranslation(["common"])

  const selectSplits = useMemo(() => {
    return dispatchesSelector();
  }, []);

  const {splits, isSplitsLoading} = useGetSplitDispatchesByDispatchQuery(dispatch.id ?? skipToken, {
    selectFromResult: (result) => ({
      splits: selectSplits(result, {}).dispatches,
      isSplitsLoading: result.isLoading
    })
  });

  return (
    <>
      {splits.length > 0 &&
        <Card shadow="sm" padding="lg" radius="md" withBorder>

          <Group position="apart" pb="sm">
            <Title order={4}>
              {t("common.entity.dispatch.profile.info.section.splits.label", "Splits")}
            </Title>
          </Group>

          <Divider/>

          <Grid>
            <Grid.Col span={12}>
              <DispatchDataTable
                withBorder
                records={splits}
                fetching={isSplitsLoading}/>
            </Grid.Col>
          </Grid>
        </Card>
      }
    </>
  )
}
